import LocalizedStrings from "react-localization";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const locale = cookies.get("locale");
const strings = new LocalizedStrings({
  en: {
    "Manage Members": "Manage Members",
  },
  ar: {
    "Manage Members": "إدارة الأعضاء",
  },
});

strings.setLanguage(locale || "en");

const translate = (string) => strings[string];

export default translate;
